// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 15 hooks for backend/lateness.

import { useBackend } from '../useBackend'

/** POST /api/lateness/confirmLateNotice */
export function useConfirmLateNotice<T = any>() {
  return useBackend<T>('lateness/confirmLateNotice')
}

/** POST /api/lateness/confirmWarningWitness */
export function useConfirmWarningWitness<T = any>() {
  return useBackend<T>('lateness/confirmWarningWitness')
}

/** POST /api/lateness/decideLatenessCase */
export function useDecideLatenessCase<T = any>() {
  return useBackend<T>('lateness/decideLatenessCase')
}

/** POST /api/lateness/getLateness */
export function useGetLateness<T = any>() {
  return useBackend<T>('lateness/getLateness')
}

/** POST /api/lateness/makeLatenessLink */
export function useMakeLatenessLink<T = any>() {
  return useBackend<T>('lateness/makeLatenessLink')
}

/** POST /api/lateness/openWarningFile */
export function useOpenWarningFile<T = any>() {
  return useBackend<T>('lateness/openWarningFile')
}

/** POST /api/lateness/recordLateNotice */
export function useRecordLateNotice<T = any>() {
  return useBackend<T>('lateness/recordLateNotice')
}

/** POST /api/lateness/recordLatenessHearing */
export function useRecordLatenessHearing<T = any>() {
  return useBackend<T>('lateness/recordLatenessHearing')
}

/** POST /api/lateness/recordLatenessNotice */
export function useRecordLatenessNotice<T = any>() {
  return useBackend<T>('lateness/recordLatenessNotice')
}

/** POST /api/lateness/recordLatenessProcedure */
export function useRecordLatenessProcedure<T = any>() {
  return useBackend<T>('lateness/recordLatenessProcedure')
}

/** POST /api/lateness/recordLatenessResponse */
export function useRecordLatenessResponse<T = any>() {
  return useBackend<T>('lateness/recordLatenessResponse')
}

/** POST /api/lateness/recordPaperWarning */
export function useRecordPaperWarning<T = any>() {
  return useBackend<T>('lateness/recordPaperWarning')
}

/** POST /api/lateness/recordWarningRefusal */
export function useRecordWarningRefusal<T = any>() {
  return useBackend<T>('lateness/recordWarningRefusal')
}

/** POST /api/lateness/reviewHandover */
export function useReviewHandover<T = any>() {
  return useBackend<T>('lateness/reviewHandover')
}

/** POST /api/lateness/signWarningUpload */
export function useSignWarningUpload<T = any>() {
  return useBackend<T>('lateness/signWarningUpload')
}
